import request from '@/utils/request'
const qs = require('qs')

// 获取产品类目
export function getcategory (data) {
  return request({
    url: '/ooh-product/v1/productskuopen/getcategory',
    method: 'post',
    data: qs.stringify(data),
    timeout: 200000
  })
}
// 获取单品分页
export function getproductsku (data) {
  return request({
    url: '/ooh-product/v1/productskuopen/getproductsku',
    method: 'post',
    data: qs.stringify(data),
    timeout: 100000
  })
}
// 获取设备信息
export function getdevicechatinfo (data) {
  return request({
    url: '/ooh-product/v1/device/getdevicechatinfo',
    method: 'post',
    data: qs.stringify(data),
    timeout: 100000
  })
}
